/**
 * meta.pPath 用于顶部菜单 选中(尤其在详情页面，其父类菜单要求时选中的)
 * meta.head 默认显示导航1，2显示导航2, -1不显示导航
 * meta.whiteBackground: 默认为灰色背景 true 为白色背景
 */
const routesActor = [{
        // 添加展品
        path: '/add-exhibit',
        name: 'AddExhibit',
        meta: {
            pPath: '/my-exhibit-list',
            title: 'Add Exhibit',
            roles: ['ACTOR']
        },
        component: () => import('../views/dash/exhibitForm'),
    },
    {
        // 编辑展品
        path: '/exhibit/:id',
        name: 'ExhibitForm',
        component: () => import('../views/dash/exhibitForm'),
        meta: {
            title: 'Edit Exhibit',
            pPath: '/my-exhibit-list',
            roles: ['ACTOR']
        }
    },
    {
        // 展品详情
        path: '/exhibit-detail/:id',
        name: 'ExhibitDetail',
        meta: {
            title: 'exhibitorInfo',
            pPath: '/my-exhibit-list',
            roles: ['ACTOR']
        },
        component: () => import('../views/dash/exhibitDetail')
    },
    {
        // 我的展品列表
        path: '/my-exhibit-list',
        name: 'MyExhibitList',
        meta: {
            title: 'My Exhibit List',
            pPath: '/my-exhibit-list',
            roles: ['ACTOR']
        },
        component: () => import('../views/dash/exhibitList')
    },
    {
        // 员工管理
        path: '/my-employee-list',
        name: 'MyEmployeeList',
        meta: {
            title: 'Employee List',
            pPath: '/my-employee-list',
            roles: ['ACTOR']
        },
        component: () => import('../views/dash/employeeList.vue')
    },
    {
        // 添加员工
        path: '/add-employee',
        name: 'AddEmployee',
        meta: {
            title: 'Add Employee',
            pPath: '/my-employee-list',
            roles: ['ACTOR']
        },
        component: () => import('../views/dash/employeeForm.vue')
    },
    {
        // 编辑员工
        path: '/employee/:id',
        name: 'EmployeeForm',
        meta: {
            title: 'Edit Employee',
            pPath: '/my-employee-list',
            roles: ['ACTOR']
        },
        component: () => import('../views/dash/employeeForm.vue')
    },
    {
        // 公司基本信息管理 展示
        path: '/company-info',
        name: 'CompanyInfo',
        meta: {
            // pPath: '/company-management',
            title: 'finds.companybaseMessManageEidt',
            whiteBackground: true,
            roles: ['ACTOR']
        },
        component: () => import('../views/dash/companyForm')
    },
    {
        // 公司基本信息管理 编辑
        path: '/company-management',
        name: 'companyManagement',
        meta: {
            pPath: '/company-management',
            title: 'companybaseMessManage',
            whiteBackground: true,
            roles: ['ACTOR']
        },
        component: () => import( /* webpackChunkName: "companyManagement" */ '../views/dash/companyManagement.vue')
    }

]

export default routesActor
